define('views/blocks/SidedishView',['hooks','jquery', 'backbone','underscore', 'router', 'app', 'SubView',
        'template!blocks/sidedish',
        'template!blocks/checkout/cross-selling',
        'views/blocks/CrossSellingItemView'
    ],

    function (hooks,$, Backbone, _, router, app, SubView,
              sidedishTemplate,
              checkoutCrossSellingTemplate,
              CrossSellingItemView
    ) {

        var SidedishView = Backbone.View.extend(SubView).extend({
            events:{
            },
            initialize: function (options) {

                var view = this;
                view.options = options;
                view.subviews = [];
                view.render();

            },
            close: function () {
                this.trigger('close', this);
            },
            render: function () {
                var view = this;
                view.$el.html(sidedishTemplate({
                    theme:view.options.theme,
                    sidedishesSteps:_(view.getSteps())
                }));

                CrossSellingItemView.initializeCrossSellingItemOfView(view);

                view.delegateEvents();
            },

            getSteps:function(){
                var t = app.t,
                    sidedishesSteps = [];
                function AppendStep(categorySlug){
                    try {
                        // utiliser le nom de la catégorie court ou à défaut le nom de la catégorie
                        var category = app.getCategoryBySlug(categorySlug + '_cross_selling'),
                            products = category.getProducts(true,true),
                            title = category.getShortName() || category.getName();
                        sidedishesSteps.push({
                            categorySlug: categorySlug,
                            key: categorySlug,
                            inputType: 'checkbox',
                            sidedish:false,
                            title: title,
                            products: products,
                            template:checkoutCrossSellingTemplate
                        });
                    }catch(err){
                    }
                }

                AppendStep('sidedish');
                AppendStep('drink');
                AppendStep('dessert');

                return sidedishesSteps;
            },

        });

        return SidedishView;

    });
